module.exports = __webpack_public_path__ + "static/media/star-exclamation.4479e686.svg";